module.exports = __webpack_public_path__ + "static/sport/out1.c55acf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/out1.png
// module id = VLod
// module chunks = 0